var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c(_setup.isRouterLink ? _setup.RouterLink : _setup.htmlEl, _vm._g(_vm._b({
    ref: "rootEl",
    tag: "component"
  }, 'component', _setup.attrs, false), _setup.on), [_vm._t("prepend"), _vm.icon ? _c('div', {
    staticClass: "list-group-item-icon flex-shrink-0 align-self-start",
    staticStyle: {
      "margin-top": "2px"
    }
  }, [_c('BaseIcon', {
    attrs: {
      "icon": _vm.icon,
      "color": _vm.iconColor
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "flex-fill",
    class: {
      'ml-2': _setup.hasPrependContent,
      'mr-2': _setup.hasAppendContent,
      'overflow-hidden': _vm.overflowHidden
    }
  }, [_vm._t("default")], 2), _vm._t("append"), _vm._t("actions")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };